/* Shopping continuity only: never writes cart, checkout or discount state. */
(() => {
  'use strict';
  const key = 'bb_shopping_size_v1';
  const normalize = value => {
    const raw = String(value || '').trim().toUpperCase();
    const canonical = ({XXL:'2XL',XXXL:'3XL'})[raw] || raw;
    return /^(S|M|L|XL|[2-9]XL|1[0-2]XL)$/.test(canonical) ? canonical : '';
  };
  const single = value => {
    const values = [...new Set(String(value || '').split(',').map(normalize).filter(Boolean))];
    return values.length === 1 ? values[0] : '';
  };
  const expanded = size => ({'2XL':['2XL','XXL'],'3XL':['3XL','XXXL']})[size] || [size];
  let selected = '';
  try { selected = normalize(sessionStorage.getItem(key)); } catch (_) {}
  const querySizes = new URLSearchParams(location.search).getAll('filter.v.option.size');
  if (querySizes.length) selected = single(querySizes.join(','));
  const navSelector = '.bb-browse-nav a,.bb-header-nav a,.header__inline-menu a,.menu-drawer a,.bb-campaign a,.bb-home__category-card,.bb-editorial a,.bb-search-help a,.bb-home__all,.bb-close__help a';
  const originals = new WeakMap();
  function render() {
    document.querySelectorAll('.bb-size-memory').forEach(bar => {
      bar.hidden = !selected;
      bar.querySelector('[data-remembered-size]').textContent = selected;
    });
    document.querySelectorAll(navSelector).forEach(link => {
      if (!originals.has(link)) originals.set(link,link.getAttribute('href'));
      const original = originals.get(link);
      if (!original) return;
      const url = new URL(original, location.origin);
      if (url.origin !== location.origin || !/^\/collections\/[^/]+\/?$/.test(url.pathname) || url.searchParams.has('filter.v.option.size')) return;
      if (selected) {
        expanded(selected).forEach(size => url.searchParams.append('filter.v.option.size', size));
        url.searchParams.set('filter.v.availability','1');
        link.setAttribute('href',url.pathname + url.search + url.hash);
        link.dataset.bbRememberedSize = selected;
      } else {
        link.setAttribute('href',original);
        delete link.dataset.bbRememberedSize;
      }
    });
  }
  function remember(value) {
    selected = single(value);
    try { if (selected) sessionStorage.setItem(key,selected); else sessionStorage.removeItem(key); } catch (_) {}
    render();
  }
  remember(selected);
  const sizeGroup = root => [...root.querySelectorAll('variant-selects .product-form__input')].find(group => /^size\b/i.test(group.querySelector('legend,.form__label')?.textContent.trim() || ''));
  document.addEventListener('submit', event => {
    const root = event.target.closest('product-info[data-update-url="true"]');
    if (!root || !event.target.querySelector('[name="id"]')) return;
    const group = sizeGroup(root);
    const control = group?.querySelector('input:checked,select');
    if (control) remember(control.value);
  }, true);
  async function restoreProductSize() {
    const root = document.querySelector('product-info[data-update-url="true"]');
    const picker = root?.querySelector('variant-selects');
    if (!picker) return;
    if (!selected && single(picker.dataset.cartSizes)) remember(single(picker.dataset.cartSizes));
    if (!selected || new URLSearchParams(location.search).has('variant') || new URLSearchParams(location.search).has('option_values')) return;
    await Promise.all([customElements.whenDefined('product-info'), customElements.whenDefined('variant-selects')]);
    const group = sizeGroup(root);
    if (!group) return;
    const control = [...group.querySelectorAll('input[type="radio"],option')].find(el => normalize(el.value) === selected);
    if (!control || control.disabled) return;
    if (control.tagName === 'OPTION') {
      if (control.selected) return;
      control.parentElement.value = control.value;
      control.parentElement.dispatchEvent(new Event('change', {bubbles:true}));
    } else {
      if (control.checked) return;
      control.checked = true;
      control.dispatchEvent(new Event('change', {bubbles:true}));
    }
  }
  restoreProductSize();
  function showSizeTarget() {
    if (location.hash !== '#bb-choose-size') return;
    const target = document.querySelector('product-info[data-update-url="true"] #bb-choose-size');
    if (!target) return;
    const header = document.querySelector('.shopify-section-header-sticky');
    const offset = (header?.getBoundingClientRect().height || 0) + 20;
    target.style.scrollMarginTop = offset + 'px';
    target.scrollIntoView({block:'start',behavior:'instant'});
    target.focus({preventScroll:true});
  }
  if (document.readyState === 'complete') requestAnimationFrame(showSizeTarget);
  else window.addEventListener('load', showSizeTarget, {once:true});
  window.addEventListener('hashchange', showSizeTarget);
  document.addEventListener('click', event => {
    const target = event.target.closest('a,button');
    if (!target) return;
    if (target.matches('[data-clear-size]')) {
      remember('');
      const url = new URL(location.href);
      if (url.searchParams.has('filter.v.option.size')) {
        url.searchParams.delete('filter.v.option.size');url.searchParams.delete('page');
        location.assign(url.href);
      }
      return;
    }
    if (target.matches('a[data-bb-filter],.bb-belief__sizes a,.bb-sf__results a,facet-remove a')) {
      const url = new URL(target.href,location.origin);
      if (url.pathname.startsWith('/collections/')) remember(url.searchParams.get('filter.v.option.size'));
    }
    if (target.matches('button[data-size]') && !target.disabled) remember(target.dataset.size);
    if (target.matches('[data-bb-chart-select]') && !target.disabled) remember(target.dataset.bbChartSelect);
  },true);
  document.addEventListener('change',event => {
    const el = event.target;
    if (el.matches('[data-bb-chart-size-select]')) remember(el.value);
    else if (el.closest('variant-selects')) {
      const group = el.closest('fieldset,.product-form__input');
      if (/size/i.test(group?.querySelector('legend,label')?.textContent || '')) remember(el.value);
    } else if (el.name === 'filter.v.option.size') {
      const form = el.closest('form');
      const values = form ? new FormData(form).getAll(el.name).join(',') : el.value;
      remember(values);
    }
  },true);
  // Facet responses replace the controls; read their committed state, including browser Back.
  const main = document.getElementById('MainContent');
  if (main) new MutationObserver(records => {
    let controls = null;
    for (const record of records) for (const node of record.addedNodes) {
      if (!(node instanceof Element)) continue;
      controls = node.matches('bb-size-browser') ? node : node.querySelector('bb-size-browser');
      if (controls) break;
    }
    if (controls) remember(controls.dataset.size);
  }).observe(main,{childList:true,subtree:true});
  window.addEventListener('pageshow',event => { if (event.persisted) render(); });

  if (!customElements.get('bb-cart-reminder')) customElements.define('bb-cart-reminder',class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.refresh = this.refresh.bind(this);
      this.updatePreview = () => {
        const preview = document.getElementById('PBarNextFrameWrapper');
        const rect = preview?.getBoundingClientRect();
        const offset = rect && rect.height > 0 && rect.top < innerHeight && getComputedStyle(preview).display !== 'none' ? Math.max(0, innerHeight - rect.top) : 0;
        this.style.setProperty('--bb-cart-preview-offset', offset + 'px');
        if (preview && this.preview !== preview) {
          this.preview = preview;
          this.previewResize?.disconnect();
          this.previewResize = new ResizeObserver(this.updatePreview);
          this.previewResize.observe(preview);
        }
      };
      this.previewWatch = new MutationObserver(this.updatePreview);
      this.previewWatch.observe(document.body,{childList:true});
      window.addEventListener('resize',this.updatePreview);
      this.updatePreview();
      this.onPageShow = event => { if (event.persisted) this.refresh(); };
      window.addEventListener('pageshow',this.onPageShow);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate,this.refresh);
    }
    disconnectedCallback() { this.ready=false;this.previewResize?.disconnect();this.previewWatch?.disconnect();window.removeEventListener('resize',this.updatePreview);this.unsubscribe?.();window.removeEventListener('pageshow',this.onPageShow); }
    async refresh() {
      if (this.pending) { this.again = true;return; }
      this.pending = true;
      try {
        const response = await fetch(this.dataset.cartUrl+'.js',{headers:{Accept:'application/json'},credentials:'same-origin',cache:'no-store'});
        if (!response.ok) return;
        const cart = await response.json();
        this.hidden = !cart.item_count;
        const count = this.querySelector('[data-cart-count]');
        count.textContent = (cart.item_count === 1 ? count.dataset.one : count.dataset.many).replace('[count]',cart.item_count);
        const images = this.querySelector('[data-cart-images]');
        images.replaceChildren();
        cart.items.slice(0,1).forEach(item => {
          const src = item.featured_image?.url || item.image;
          if (!src) return;
          const url = new URL(src,location.origin);
          if (url.protocol !== 'https:') return;
          url.searchParams.set('width','120');
          const image = document.createElement('img');image.src = url.href;image.alt='';image.width=48;image.height=60;image.loading='lazy';images.append(image);
        });
      } catch (_) { /* Existing cart link remains available if refresh fails. */ }
      finally { this.pending=false;if (this.again) {this.again=false;this.refresh();} }
    }
  });
})();

